import { Panel, Modal } from '@studiometa/ui';

/**
 * ListingPanel component
 */
export default class ListingPanel extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    ...Panel.config,
    name: 'ListingPanel',
    refs: [...(Modal.config.refs || []), ...(Panel.config.refs || []), 'reset[]'],
    emits: [...(Panel.config.emits || []), 'reset'],
  };

  /**
   * Emit the reset event
   */
  onResetClick() {
    this.$emit('reset');
  }
}
